import { faLock, faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import LogoAndText from "../components/LogoAndText";
import { userLogin } from "../apiServices/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToastContainer from "../components/CustomToastContainer.js";

export default function LoginForm() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      phone,
      password,
    };

    try {
      const response = await userLogin(data);
      // console.log("Response ...: ", response);
      if (response && response.success) {
        const passenger = response.data.passenger;
        const token = response.data.access_token.access_token;
        localStorage.setItem("user", JSON.stringify(passenger));
        localStorage.setItem("access_token", JSON.stringify(token));
        window.location.replace("/");
      } else {
        console.error(
          "Login failed or unexpected response structure",
          response
        );
        toast.error(response.message || "Login failed");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <>
      <div className="bg-gray-100 flex flex-col items-center justify-center h-screen p-4 md:p-10">
        <div className="w-full md:w-1/2 py-10 md:py-20">
          <div className="mb-10">
            <LogoAndText />
          </div>
          <h1 className="text-gray-600 font-semibold text-md md:text-lg text-center mb-6 md:mb-8">
            Welcome back
          </h1>
          <div className="flex justify-center">
            <form
              className="w-full sm:w-3/4 md:w-1/2"
              id="myForm"
              onSubmit={handleSubmit}
            >
              <div className="mb-6 md:mb-8">
                <div className="relative z-0 w-full mb-5 group">
                  <FontAwesomeIcon
                    icon={faMobileScreen}
                    className="absolute text-[#BE1F18] left-0 top-3"
                  />
                  <input
                    type="text"
                    name="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    id="floating_phone"
                    className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                    placeholder=" "
                    required
                  />
                  <label
                    htmlFor="floating_phone"
                    className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Phone Number
                  </label>
                </div>
              </div>
              <div className="relative z-0 w-full mb-6 group">
                <FontAwesomeIcon
                  icon={faLock}
                  className="absolute text-[#BE1F18] left-0 top-3"
                />
                <input
                  type="password"
                  name="password"
                  id="floating_password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="floating_password"
                  className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Password
                </label>
              </div>
              <Link
                to="/forgotPassword"
                className="text-[#BE1F18] font-bold text-xs md:text-sm text-end block mx-auto mt-6 mb-6 md:mb-8"
              >
                Forgot Password?
              </Link>
              <button
                type="submit"
                className="bg-[#BE1F18] text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center"
              >
                Login
              </button>

              <Link
                to="/signup"
                className="mt-4 text-[#BE1F18] border border-[#BE1F18] focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center block"
              >
                Sign up
              </Link>
              {/* <h1 className="text-gray-600 font-semibold text-xs md:text-sm text-center mt-6 mb-6 md:mb-8">
                Or
              </h1>
              <Link
                to="/"
                className="text-[#BE1F18] underline font-bold text-xs md:text-sm text-center block mx-auto mt-6 mb-6 md:mb-8"
                
              >
                Proceed As Guest
              </Link> */}
            </form>
          </div>
        </div>
      </div>
      <CustomToastContainer />
    </>
  );
}
